module.exports = __webpack_public_path__ + "img/leave-icon.a968e5b5.png";